<div class="container-div">

  <div >
    <h3 class="text-accent dialog-title">Rearrange Columns</h3>
    <div class="divider bg-accent chamfer"></div>
  </div>

  <div class="rearrange-container-list chamfer display-block" (cdkDropListDropped)="reorderColumns($event)" cdkDropList>
    <div class="rearrange-items flex-space-between" *ngFor="let column of totalColumns" cdkDrag cdkDragLockAxis="y"
      cdkDragBoundary=".rearrange-container-list">
      {{ mapping[column] }}
    </div>
  </div>

  <div class="text-center save-button-container">
    <button color="warn" type="submit" mat-stroked-button (click)="closeDialog()">Cancel</button>

    <button color="accent" type="submit" (click)="saveColumnOrder()" mat-flat-button 
      [disabled]="!totalColumns || (totalColumns.length <= 1)">Save</button>

  </div>
</div>
